import React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useCommonStyles } from "../../utils";
import { Box, InputLabel, Typography } from "@mui/material";

const CommonCheckbox = ({
  checkLabels = [],
  name,
  selectedValue = [],
  handleChange,
  flexDirection,
  color,
  borderRadius,
  padding,
  border,
  marginLeft,
  marginRight,
  text,
  labelColor,
  fontWeight,
  fontSize,
  marginBottom,
  valid
}) => {
  const { classes } = useCommonStyles();

  return (
    <>
      {text && (
        <Box display={"flex"} gap={'2px'}>
          <InputLabel
            className={classes.label}
            sx={{
              fontWeight: fontWeight ? fontWeight : "500",
              fontSize: fontSize ? fontSize : "14px",
              fontFamily: "Satoshi-Medium",
              color: labelColor || "#2E2E30",
              marginBottom: marginBottom || "8px",
              textTransform: "capitalize",
            }}
          >
            {text}
          </InputLabel>
          {valid && (
            <Typography height={'5px'} color="#EF627A" component={"caption"} variant={"body2"}>
              *
            </Typography>
          )}
        </Box>
      )}

      <FormGroup
        sx={{ display: "flex", flexDirection: flexDirection || "colomn" }}
      >

        {checkLabels.map((item, index) => (
          <FormControlLabel
            key={index}
            className={classes.checkBox}
            sx={{
              border: border || "none",
              borderRadius: borderRadius || "none",
              padding: padding || "none",
              "&.MuiFormControlLabel-root": {
                marginLeft: marginLeft || "-11px",
                marginRight: marginRight || "16px",
                "& .MuiFormControlLabel-label": {
                  color: color ? color : "#8F8F8F",
                  fontFamily: "Satoshi-Medium"
                },
              },
            }}
            control={
              <Checkbox
                checked={selectedValue.includes(item?.id)}
                onChange={handleChange}
                value={item?.id}
                icon={
                  <img
                    src="/assets/img/uncheck.svg"
                    alt=""
                    style={{ height: "16px", width: "16px" }}
                  />
                }
                checkedIcon={
                  <img
                    src="/assets/img/check.svg"
                    alt=""
                    style={{ height: "16px", width: "16px" }}
                  />
                }
              />
            }
            label={item?.label}
          />
        ))}
      </FormGroup>
    </>
  );
};

export default CommonCheckbox;
